import { Tab, Tabs } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const AntTabs = Tabs;

export const AntTab = withStyles(() => ({
  root: {
    minWidth: 10,
    fontSize: '.825rem',
  },
}))(Tab);
